export const PRESCRIPTION_FOLLOWS_MODAL = 'prescription-follows-modal'
